export const colors = {
  text: "#0c0d0e",
  primary: "#0f3d70",
  secondary: "#cce7ff",
  tertiary: "#0667ba",
  accent: "#ed780f",
};
